import i18n from '@/i18n'

/**
 * Formats an ISO date string as dd/mm/yyyy (pt-BR) or mm/dd/yyyy (en-US),
 * always using the active app language from i18next.
 *
 * Components that subscribe to language changes via useTranslation will
 * automatically re-render with the updated format when the locale switches.
 */
export function formatDate(iso: string): string {
  const locale = i18n.language || 'pt-BR'
  return new Date(iso).toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
